import { render, staticRenderFns } from "./ColorsApi.vue?vue&type=template&id=96814476&"
import script from "./ColorsApi.vue?vue&type=script&lang=js&"
export * from "./ColorsApi.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports